import type { AppContext } from 'types/common'

import { graphql } from '$houdini'
import { getSession } from 'stores/session'
import VehicleSearch from './VehicleSearch.svelte'
import { type ParsedStateParameters, jsonParseParameters } from 'utility/search-fields'

const dataQuery = graphql(`
	query VehicleSearchData {
		session {
			userAccount {
				authorizedStores {
					id
					name
					code
				}
				settings {
					searchVehicles {
						pinnedSearchFields
					}
				}
			}
		}
	}
`)

/* settings {
	searchVehicles {
		pinnedSearchFields
	}
} */

export default function ({ stateRouter }: AppContext) {
	stateRouter.addState({
		name: 'app.vehicle-search',
		route: 'vehicle-search',
		querystringParameters: [],
		template: {
			svelte: true,
			component: VehicleSearch,
		},
		async resolve(_stateRouterData, parameters) {
			const { currentStore } = getSession()

			const parsedParameters: ParsedStateParameters = {}
			for (const key in parameters) {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
				parsedParameters[key] = jsonParseParameters.has(key) ? JSON.parse(parameters[key]) : parameters[key]
			}

			const { data } = await dataQuery.fetch()

			return {
				parsedParameters,
				authorizedStores: data?.session?.userAccount?.authorizedStores ?? [],
				stores: currentStore ? [currentStore] : [], //This is the list of selected stores, so by default it will be their currently logged in store
				userPinnedSearchFields: data?.session?.userAccount?.settings?.searchVehicles?.pinnedSearchFields ?? [],
			}
		},
	})
}
